module.exports = __webpack_public_path__ + "img/2.b1d5a07d.jpg";